import styled from 'styled-components';
import { themeGet } from 'styled-system';
import { Card } from 'core/components';

const BoardCard = styled(Card)`
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  transition: none !important;
  flex: 1;
  margin: 1px;

  &.type-section {
    box-shadow: none;
  }

  &.text-transparent-bg {
    background: transparent !important;
    box-shadow: none !important;
    border: none;
  }

  &.editing {
    outline: 2px solid ${themeGet('colors.decks.cardBorderDragging')};
  }

  &.highlighted {
    outline: 3px solid ${themeGet('colors.primary')};
  }

  &.interactive {
    flex: unset;

    .drag-header,
    .item-drag-header {
      cursor: grab;

      &:active {
        cursor: grabbing;
      }

      &:hover {
        background-color: ${themeGet('colors.decks.headerHover')};
      }
    }

    .config-menu.floating,
    .widget-tooltip {
      visibility: hidden;
    }

    &:hover {
      .config-menu.floating,
      .widget-tooltip {
        visibility: visible;
      }

      &.react-resizable {
        > .react-resizable-handle {
          position: absolute;
          border: solid ${themeGet('colors.decks.handles')};
          padding: 10px;
          margin: 4px;
          z-index: 10;

          &.react-resizable-handle-se {
            cursor: se-resize;
            bottom: -2px;
            right: -2px;
            border-width: 0 2px 2px 0;
            border-radius: 0 0 3px 0;
            border-color: ${themeGet('colors.decks.handlesHover')};
          }
        }
      }

      &.react-resizable-hide {
        > .react-resizable-handle {
          display: none;
        }
      }
    }

    &.resizing {
      border: 2px solid ${themeGet('colors.decks.cardBorderDragging')};

      .react-resizable-handle {
        border-color: ${themeGet('colors.decks.handles')};
      }
    }

    &.react-draggable-dragging {
      border: 2px solid ${themeGet('colors.decks.cardBorderDragging')};

      > div {
        opacity: 0.25;
      }
    }
  }
`;

export default BoardCard;
